__turbopack_context__.v({
  "actionsWrapper": "NavigationMainMenu-module-scss-module__H-JS0G__actionsWrapper",
  "appCtaButton": "NavigationMainMenu-module-scss-module__H-JS0G__appCtaButton",
  "appCtaItem": "NavigationMainMenu-module-scss-module__H-JS0G__appCtaItem",
  "bookmarkIcon": "NavigationMainMenu-module-scss-module__H-JS0G__bookmarkIcon",
  "desktopBookmarkLink": "NavigationMainMenu-module-scss-module__H-JS0G__desktopBookmarkLink",
  "menu": "NavigationMainMenu-module-scss-module__H-JS0G__menu",
  "menuItem": "NavigationMainMenu-module-scss-module__H-JS0G__menuItem",
  "mobileBookmarkItem": "NavigationMainMenu-module-scss-module__H-JS0G__mobileBookmarkItem",
  "mobileBookmarkLink": "NavigationMainMenu-module-scss-module__H-JS0G__mobileBookmarkLink",
  "mobileLabel": "NavigationMainMenu-module-scss-module__H-JS0G__mobileLabel",
  "mobileSection": "NavigationMainMenu-module-scss-module__H-JS0G__mobileSection",
  "mobileSectionLabel": "NavigationMainMenu-module-scss-module__H-JS0G__mobileSectionLabel",
  "navLink": "NavigationMainMenu-module-scss-module__H-JS0G__navLink",
  "open": "NavigationMainMenu-module-scss-module__H-JS0G__open",
});
